import Component from './alert-log.component';

export default Component;
